/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AccountFilterModel,
  FeatureName,
  PermissionValues,
  useAccountFilter,
  useCurrentAccount,
  useCurrentWorkspace,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { SlideLayout } from '@gripp/shared-ui';
import { useCallback, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useParams } from 'react-router-dom';
import { AccountGroups } from './accountGroups';
import { AccountList } from './accountList';
import { Accounts as AccountsOld } from './accounts-old';
import { AccountsFilters } from './accountsFilters';

export const Accounts = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleEnabled) {
    return <AccountsBase />;
  }

  return <AccountsOld />;
};

const AccountsBase = () => {
  const leftColumn = {
    title: 'people.menu.people',
    mainComponent: <AccountsComponent />,
    headerComponent: <AccountsFilters />,
  };

  return (
    <SlideLayout 
      leftColumn={leftColumn}
    />
  )
};

const AccountsComponent = () => {
  const { workspaceId } = useParams();
  const { data: accountFilter, isLoading: isLoadingFilter } = useAccountFilter();
  const { account } = useCurrentAccount();
  const [rowsSelected, setRowsSelected] = useState(Array<any>);

  const workspace = useCurrentWorkspace(true);

  const showCheckboxColumn = useMemo(
    () => !!workspace,
    [workspace]
  );

  const isGlobalAdmin = useMemo(
    () => !!(account && account.hasPermission(PermissionValues.globalAdmin)),
    [account]
  );

  const currentWorkspaceId = useCallback(() => {
    if (workspaceId) {
      return workspaceId;
    }

    if (workspace) {
      return workspace.id;
    }

    return undefined;
  }, [workspace, workspaceId]);

  const filter = useMemo(() => {
    if (!accountFilter || workspace === undefined) {
      return null;
    }

    const filter: AccountFilterModel = new AccountFilterModel(accountFilter);
    filter.workspaceId = currentWorkspaceId();

    return filter.getGraphQLFilter();
  }, [accountFilter, workspace, currentWorkspaceId]);

  const updateRowsSelected = useCallback((rows: Array<any>) => {
    setRowsSelected(rows.map(row => row.id));
  }, []);

  const AddToGroups = () =>
    showCheckboxColumn ? (
      <AccountGroups
        accountIds={rowsSelected}
        workspaceId={currentWorkspaceId() as string}
      />
    ) : null;

  if (isLoadingFilter) {
    return null;
  }

  return !filter ? null : (
    <View style={styles.container}>
      <AccountList
        filter={filter}
        updateRowsSelected={updateRowsSelected}
        showCheckboxColumn={showCheckboxColumn}
        showRolesColumn={!!currentWorkspaceId()}
        showImpersonateWorkspace={isGlobalAdmin}
        showImpersonateUser={isGlobalAdmin}
        showGlobalAdminRole={isGlobalAdmin}
        addToGroupsComponent={<AddToGroups />}
        workspaceId={currentWorkspaceId()}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
  exportContainer: {
    marginLeft: 'auto',
  },
});
